




import { Vue, Component, ProvideReactive } from 'vue-property-decorator'
import { mapState } from 'vuex'
import LoginHero from '@/components/login/LoginHero.vue'


@Component({
  components: { LoginHero },
  computed: {
    ...mapState('authentication', {
      flashMessages: 'messages',
    }),
  },
})
export default class Login extends Vue {
  @ProvideReactive()
  flashMessages!: object

  async created() {
    console.log('v2023-09-29')
  }
}
